import {useBoolean} from 'react-hanger';
import {useEffect} from "react";


const Index = (props) => {
  let {children, isShow} = props;

  let isFirstRender = useBoolean(true)

  useEffect(() => {
    isFirstRender.setFalse()
  }, [isShow])


  if (!isShow && isFirstRender.value) {
    return null
  }

  return <>
    {children}
  </>
}


export default Index;
